<template>
    <div>
      <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin"></i></div>
      <div v-else-if="articles.length == 0" class="text-center py-3">No articles</div>
        <table v-else class="datatables-basic table">
          <tbody>
            <tr v-for="(article, index) in articles" :key="index.id">
              
              <td class="pr-3 pl-2 pb-3 px-4">  

                <div v-if="status != 1" >
                <a href="#/" @click="openUrl('view',article.id,article.title,article.status)" class="blackblue"><b>{{ article.title }}</b></a>
                <div class="mb-0"><small>{{ article.scheduled }}</small></div>
                </div>

                <a v-else href="#/" @click="openUrl('view',article.id,article.title,article.status)" class="blackblue"><b>New article</b></a>
                               
              <div class="mt-2">
                <a href="#/" v-if="status != 1" class="mr-2" @click="openUrl('view',article.id,article.title,article.status)">View</a>
                <a href="#/" @click="openUrl('edit',article.id,article.title,article.status)">Edit</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
  </div>
</template> 

<script>
export default {
  props: ['status','user'],

  data() {
    return {
      articles: [],
      tabIndex: 0,
      loading: false,
      default_image: 'https://property64.s3.af-south-1.amazonaws.com/images/image-not-found-1280x820.png',
    };
  },

  created() {
    this.getArticles();
  },

  methods: {
    getArticles() {
      this.loading = true;

      axios.post(`/articles/getnew`, {status: this.status}).
      then((response) => {
        this.articles = response.data;
        this.loading = false;
      });
    },

    openUrl(action, article_id, title, status) {
      
      var url = '';

      if (status=='Incomplete' || action=='edit') url = '/articles/edit/'+article_id;
      else url = '/article/'+article_id+'/'+this.makeSlug(title);

      window.open(url, '_self');
 
    },
  },
};
</script>